@if (contextLoading()) {
  <p class="m-0 text-sm text-secondary">Loading available actions…</p>
} @else {
  @if (showAction('apply')) {
    <button
      type="button"
      class="inline-flex w-full items-center justify-center primary-button disabled:opacity-50 disabled:cursor-not-allowed"
      [disabled]="actionLoading()"
      (click)="apply.emit()">
      @if (actionLoading()) {
        Applying…
      } @else {
        Apply on behalf of creator
      }
    </button>
  }

  @if (showAction('submit-content')) {
    <ins-creator-submit-content [application]="application()" />
  }

  @if (showAction('upload-instructions')) {
    <ins-creator-upload-instructions [application]="application()" />
  }

  @if (showAction('post-primary') && creator() && approvedVideos()) {
    <ins-creator-post-on-platform
      [application]="application()"
      [creator]="creator()!"
      [approvedVideos]="approvedVideos()!"
      [submittedPosts]="submittedPosts()"
      [submittablePosts]="submittablePosts()"
      mode="primary"
      (submittablePostsChange)="onSubmittablePostsChange($event)"
      (submittedPostsChange)="onSubmittedPostsChange($event)" />
  }

  @for (platform of crossPostPlatforms(); track platform) {
    @if (creator() && approvedVideos()) {
      <ins-creator-post-on-platform
        [application]="application()"
        [creator]="creator()!"
        [approvedVideos]="approvedVideos()!"
        [submittedPosts]="submittedPosts()"
        [submittablePosts]="submittablePosts()"
        [platform]="platform"
        mode="cross"
        (submittablePostsChange)="onSubmittablePostsChange($event)"
        (submittedPostsChange)="onSubmittedPostsChange($event)" />
    }
  }
}
